<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="OSOBATELEFON.SINGULAR"></span></h2>
    <h1 class="modal-title">
      <!-- <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="OSOBATELEFON.NEW"></span></span> -->
      <span><span translate="OSOBATELEFON.NEW"></span></span>
      <!-- <span *ngIf="baseUpdate.Item.ID > 0"><span>{{baseUpdate.Item.Naziv}}</span></span>         -->
    </h1>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <yt-osoba-telefon-update #baseUpdate></yt-osoba-telefon-update>
</div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary" (click)="Save()"><span>Sačuvaj</span></button>
  <button type="button" class="btn btn-secondary" (click)="Close()"><span>Zatvori</span></button>
</div>